import React from 'react'
import styled from 'styled-components'

// Utils
import { useAppState } from '../context/AppContext'
import { IconType } from './icon/IconType'

// Components
import { Icon } from './icon'
import { RowAligned } from './layout/LayoutAtoms'
import StatusTag from './tag/StatusTag'
import Text from './Text'

interface IResultsHeaderProps {
  title: string
  resultsLength: number
  icon?: IconType
  rightLabel?: string
  // Right-aligned slot for a control (e.g. the Assessors/Results view toggle).
  rightContent?: React.ReactNode
  className?: string
}

const ResultsHeader: React.FC<IResultsHeaderProps> = ({
  title,
  resultsLength,
  icon,
  rightLabel,
  rightContent,
  className,
}) => {
  const { theme } = useAppState()

  return (
    <Container className={className}>
      {icon && <Icon type={icon} color={theme.colors.textLight} size={16} />}
      <Text textStyle="labelSmallCaps" color="textLight">
        {title}
      </Text>
      <StyledTag caption={resultsLength} color="lightest" captionColor="text" />
      {rightLabel && (
        <StyledText textStyle="labelSmallCaps" color="textLight">
          {rightLabel}
        </StyledText>
      )}
      {rightContent && <RightContent>{rightContent}</RightContent>}
    </Container>
  )
}

const Container = styled(RowAligned)`
  padding: 4px 16px;
  background-color: ${({ theme }) => theme.colors.textLightest};
  border-radius: 4px;
  margin: 12px 0 8px;
`

const StyledTag = styled(StatusTag)`
  margin-left: 8px;
`

const StyledText = styled(Text)`
  margin-left: auto;
`

const RightContent = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`

export default ResultsHeader
